(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/shared-wagers.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/shared-wagers.js');

'use strict';

const {
  useAtomValue
} = jotai;
const {
  wagersAtom,
  currentWagerIdAtom
} = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms;
const {
  wagerHelper
} = svs.lyckoplatsen.shared_mybets_wager.utils;
const {
  FinishedWagerSummary,
  OngoingWagerSummary
} = svs.lyckoplatsen.components.shared_mybets_wager.react.components;
const SharedWagers = _ref => {
  let {
    isOngoing = false
  } = _ref;
  const {
    selectedResultAtom
  } = svs.lyckoplatsen.components.shared_result.jotai.atoms;
  const wagers = useAtomValue(wagersAtom);
  const currentWagerId = useAtomValue(currentWagerIdAtom);
  const result = useAtomValue(selectedResultAtom);
  const firstWager = wagers.find(wager => wager.wagerId === currentWagerId);
  const wagersWithoutFirst = wagers.filter(wager => wager.wagerId !== currentWagerId);
  const sortedWagersWithWin = wagersWithoutFirst.filter(wager => wagerHelper.getWin(wager, result)).sort((wagerA, wagerB) => parseFloat(wagerHelper.getWin(wagerB, result).amount) - parseFloat(wagerHelper.getWin(wagerA, result).amount));
  const wagersWithoutWin = wagersWithoutFirst.filter(wager => !wagerHelper.getWin(wager, result));
  const sortedProlongableWagers = wagersWithoutWin.filter(wager => wagerHelper.getIsProlongable(wager)).sort((wagerA, wagerB) => new Date(wagerA.regWagerTime) - new Date(wagerB.regWagerTime));
  const nonProlongableWagers = wagersWithoutWin.filter(wager => !wagerHelper.getIsProlongable(wager));
  const sortedSubWagers = nonProlongableWagers.filter(wager => wager.isSubscription).sort((wagerA, wagerB) => new Date(wagerA.regWagerTime) - new Date(wagerB.regWagerTime));
  const sortedOtherWagers = nonProlongableWagers.filter(wager => !wager.isSubscription).sort((wagerA, wagerB) => new Date(wagerA.regWagerTime) - new Date(wagerB.regWagerTime));
  const sortedWagers = [firstWager, ...sortedWagersWithWin, ...sortedProlongableWagers, ...sortedOtherWagers, ...sortedSubWagers].filter(wager => Boolean(wager));
  if (isOngoing) {
    return React.createElement("div", null, React.createElement("div", {
      className: "lp-wagers margin-v-1"
    }, React.createElement("div", {
      className: "wagers-body"
    }, wagers.map(wager => React.createElement(OngoingWagerSummary, {
      key: wager.wagerId,
      wager: wager
    })))));
  }
  return React.createElement("div", {
    className: "lp-wagers margin-v-1"
  }, React.createElement("div", {
    className: "wagers-body"
  }, sortedWagers.map(wager => React.createElement(FinishedWagerSummary, {
    key: wager.wagerId,
    wager: wager
  }))));
};
setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.react.components', {
  SharedWagers
});

 })(window);